import { toNormalizedMessage } from '@/shared/utils/sentry/clientIgnoreRules/stringMatchers';
import {
  ClientSentryEventContext,
  ClientSentryIgnoreRule,
} from '@/shared/utils/sentry/clientIgnoreRules/types';

const EMPTY_OBJECT_UNHANDLED_REJECTION_MESSAGE =
  'object captured as promise rejection with keys: [object has no keys]';

const AFFECTED_ROUTE = '/v/lots/submissions';
const LOCALIZED_AFFECTED_ROUTE =
  /^\/(?:[a-z]{2}|zh-(?:Hans|Hant))\/v\/lots\/submissions$/;

const isAffectedRoute = (pathname: string | null | undefined): boolean =>
  pathname === AFFECTED_ROUTE ||
  (typeof pathname === 'string' && LOCALIZED_AFFECTED_ROUTE.test(pathname));

const hasActionableContext = ({
  hasExceptionStacktrace,
  hasAppFrameInStacktrace,
}: ClientSentryEventContext): boolean =>
  hasExceptionStacktrace || hasAppFrameInStacktrace;

export const nonErrorEmptyObjectUnhandledRejectionRule: ClientSentryIgnoreRule =
  {
    id: 'non-error-empty-object-unhandled-rejection',
    references: ['FTR-3408'],
    reason:
      'Opaque non-error rejection on the affected route without usable seller-ui stack or app-frame context',
    matches: (context) => {
      if (context.firstExceptionType !== 'UnhandledRejection') {
        return false;
      }

      if (hasActionableContext(context)) {
        return false;
      }

      if (!isAffectedRoute(context.requestUrlPathname)) {
        return false;
      }

      return (
        toNormalizedMessage(context.serializedMessage) ===
        EMPTY_OBJECT_UNHANDLED_REJECTION_MESSAGE
      );
    },
  };
